@if(currentView === views.Home) {
  <div class="container">
    <button (click)="selectView(views.Backups)" class="request-button">Ver Backups</button>

    <button (click)="selectView(views.CreatingBackup)" class="request-button">Crear Backup</button>
  </div>

  <!-- <div class="backups-searched-container">
    <div class="backup-search-information">
      <p class="text-info">Devuelve la información de un backup (GET).</p>
      <button (click)="getBackup()">Buscar Backup</button>
      <div class="date-input-container">
        <input type="text" [(ngModel)]="backupDateToSearch" class="date-input" placeholder="Fecha">
        @if(backupNotFound) {
          <p class="backup-not-found">Backup no encontrado</p>
        }
      </div>
    </div>

    <div class="backup-searched">
      <p><strong>Fecha: </strong>{{backupSearched ? (backupSearched.fecha | date:'dd/MM/yyyy HH:mm:ss') : ''
      }}</p>
      <p><strong>Último Cambio: </strong>{{backupSearched ? (backupSearched.ultimoCambio | date:'dd/MM/yyyy HH:mm:ss') : ''}}</p>
      <p><strong>Comentario: </strong>{{backupSearched ? backupSearched.comentario : ''}}</p>
      <p><strong>Protegido: </strong>{{backupSearched && backupSearched.protegido ? (backupSearched.protegido ? 'Si' :
        'No') : ''}}</p>
      <p><strong>Edición: </strong>{{backupSearched && backupSearched.edicion ? (backupSearched.edicion ? 'Si' : 'No') :
        ''}}</p>
    </div>
  </div> -->
}

@if(currentView === views.Backups) {
  <div class="search-container">
    <button class="back-button button button-colors" (click)="selectView(views.Home)">Volver</button>
  </div>

  <!-- Vista de backups -->
  <div class="scroll-container">
    @if (!!globalService.backupToPreview) {
      <p class="visualize-backup-text">Backup visualizado: {{globalService.backupToPreview.fecha | date:'dd/MM/yyyy HH:mm:ss'}}</p>
    }

    @for(backup of backups; track backup.fecha.toString()) {
      <div class="backup">
        <div class="backup-row">
          <p class="backup-data"><strong>Fecha:</strong> {{(backup.fecha | date:'dd/MM/yyyy HH:mm:ss')}}</p>

          <p class="backup-data"><strong>Último Cambio:</strong> {{(backup.ultimoCambio | date:'dd/MM/yyyy HH:mm:ss')}}</p>
        </div>

        <div class="backup-row">
          <p class="backup-data"><strong>Protegido:</strong> {{backup.protegido ? 'Si' : 'No'}}</p>

          <p class="backup-data"><strong>Edición:</strong> {{backup.edicion ? 'Si' : 'No'}}</p>
        </div>

        <p class="backup-comment"><strong>Comentario:</strong> {{backup.comentario}}</p>

        <div class="backup-buttons">
          <button class="delete-button" (click)="deleteBackup(backup)">
            <img src="assets/icons/delete.svg">
            <span>Eliminar</span>
          </button>

          <button class="restore-button" (click)="selectView(views.RestoringBackups, backup)">
            <img src="assets/icons/backup-restore.svg">
            <span>Restaurar</span>
          </button>

          <button class="visualize-button" (click)="startBackupPreview(backup)" [disabled]="!!globalService.backupToPreview" 
            [ngClass]="{'disabled-visualize-button': !!globalService.backupToPreview}">
            <img src="assets/icons/eye.svg">
            <span>Visualizar</span>
          </button>

          <button class="compare-button" (click)="selectView(views.BackupComparison, backup)">
            <img src="assets/icons/compare.svg">
            <span>Comparar</span>
          </button>

          <button class="modify-button" (click)="selectView(views.EditingBackups, backup)">
            <img src="assets/icons/edit.svg">
            <span>Modificar</span>
          </button>
        </div>
      </div>
    }
  </div>
}

<!-- Vista de crear y editar backup -->
@if(currentView === views.CreatingBackup || currentView === views.EditingBackups) {
  <div class="create-backup-container">
    <h4>{{currentView === views.CreatingBackup ? 'Crear backup' : 'Editando backup con fecha "' + (!!backupSelected ? (backupSelected.fecha | date:'dd/MM/yyyy HH:mm:ss') + '"' : '')}}</h4>

    <textarea class="new-comment-textarea" [(ngModel)]="comment" placeholder="Comentario"></textarea>

    <label class="protected-checkbox inline">
      <input class="checkbox" type="checkbox" [(ngModel)]="protegido">
      <p>Protegido</p>
    </label>

    <div class="create-buttons">
      <button class="button button-colors" (click)="currentView === views.CreatingBackup ? selectView(views.Home) : selectView(views.Backups)">Volver</button>

      <button class="button button-colors" (click)="currentView === views.CreatingBackup ? createBackup() : editBackup()">Confirmar</button>
    </div>
  </div>
}

<!-- Vista de restaurar backup -->
@if(currentView === views.RestoringBackups) {
  <div class="restore-backup-container">
    <h4>Restaurando backup con fecha "{{!!backupSelected ? (backupSelected.fecha | date:'dd/MM/yyyy HH:mm:ss') : ''}}"</h4>

    <p>Selecciona las opciones que quieras restaurar.</p>

    <div class="row-options">
      <div class="restore-option inline">
        <p>Actualizaciones</p>
        <label class="switch">
          <input type="checkbox" [(ngModel)]="postRestoreBackupRequest.actualizaciones">
          <span class="slider round"></span>
        </label>
      </div>

      <div class="restore-option inline">
        <p>IPs</p>
        <label class="switch">
          <input type="checkbox" [(ngModel)]="postRestoreBackupRequest.iPs">
          <span class="slider round"></span>
        </label>
      </div>
    </div>

    <div class="row-options">
      <div class="restore-option inline">
        <p>Aplicaciones</p>
        <label class="switch">
          <input type="checkbox" [(ngModel)]="postRestoreBackupRequest.aplicaciones">
          <span class="slider round"></span>
        </label>
      </div>

      <div class="restore-option inline">
        <p>M2Ms</p>
        <label class="switch">
          <input type="checkbox" [(ngModel)]="postRestoreBackupRequest.m2Ms">
          <span class="slider round"></span>
        </label>
      </div>
    </div>

    <div class="row-options">
      <div class="restore-option inline">
        <p>ConnectionStrings</p>
        <label class="switch">
          <input type="checkbox" [(ngModel)]="postRestoreBackupRequest.connectionStrings">
          <span class="slider round"></span>
        </label>
      </div>

      <div class="restore-option inline">
        <p>Secretos</p>
        <label class="switch">
          <input type="checkbox" [(ngModel)]="postRestoreBackupRequest.secretos">
          <span class="slider round"></span>
        </label>
      </div>
    </div>

    <div class="row-options">
      <div class="restore-option inline">
        <p>Grupos</p>
        <label class="switch">
          <input type="checkbox" [(ngModel)]="postRestoreBackupRequest.grupos">
          <span class="slider round"></span>
        </label>
      </div>

      <div class="restore-option inline">
        <p>TokensCfg</p>
        <label class="switch">
          <input type="checkbox" [(ngModel)]="postRestoreBackupRequest.tokensCfg">
          <span class="slider round"></span>
        </label>
      </div>
    </div>

    <div class="restore-buttons">
      <button class="button button-colors" (click)="selectView(views.Backups)">Volver</button>

      <button class="restore-button button button-colors" (click)="restoreBackup()" [disabled]="!globalService.editing">Confirmar</button>
    </div>
  </div>
}

<!-- Vista de comparación de backups -->
@if(currentView === views.BackupComparison) {
  <div class="search-container compare-backups-title-container">
    <p class="compare-backups-title">Comparación de backups</p>

    <button class="button button-colors" (click)="selectView(views.Backups)">Volver</button>
  </div>

  <div class="scroll-container">
    <div class="compare-backups-container">
      <div class="compare-backups-select-container">
        <p class="compare-backups-selected-backup">Backup seleccionado: {{!!backupSelected ? (backupSelected.fecha | date:'dd/MM/yyyy HH:mm:ss') : ''}}</p>

        <select [(ngModel)]="item2" class="compare-backups-select">
          @for(backupOption of backupsOptions; track backupOption.key) {
            @if (backupOption.value !== item1) {
              <option [value]="backupOption.value">{{backupOption.key}}</option>
            }
          }
        </select>
      </div>

      <!-- No debería pasar nunca, pero por si acaso -->
      @if (showCompareBackupsError) {
        <p class="compare-backups-error">Los backups seleccionados deben ser diferentes.</p>
      }

      <div class="compare-backups-button-container">
        <button class="button button-colors" (click)="compareBackups()">Comparar</button>
      </div>

      @if (!backupComparisonInProgress) {
        @if (backupComparison !== '') {
          <div class="comparison-container" [innerHTML]="backupComparison"></div>
        } @else {
          <p class="no-changes-text">No hay cambios</p>
        }
      }
    </div>
  </div>
}